import googleApikeys from "../assets/googleApiKeys.json";

const GOOGLE_MAPS_API_KEY_MAP = {
  SL: googleApikeys,
  BG: googleApikeys,
  IN: googleApikeys,
};

let CATALOG_MENU_API_KEY = window._siteProps_?.props?.catalog_menu_api_key;
let TENANT_KEY = window._siteProps_?.props?.tenantKey;
let TENANT = window._siteProps_?.props?.tenant;
let TENANT_ID = window._siteProps_?.props?.tenantID;
let CHANNEL_ID = window._siteProps_?.props?.channelId;

const APP_VERSION = window._siteProps_?.props?.app_version;

const AMPLITUDE_KEY = window._siteProps_?.props?.amplitude_key;

const MOENGAGE_KEY = window._siteProps_?.props?.moengage_key;

const META_EVENTS_KEY = window._siteProps_?.props?.meta_key;

export default {
  GOOGLE_MAPS_API_KEY_MAP,
  APP_VERSION,
  CATALOG_MENU_API_KEY,
  AMPLITUDE_KEY,
  MOENGAGE_KEY,
  TENANT_KEY,
  TENANT,
  TENANT_ID,
  CHANNEL_ID,
  META_EVENTS_KEY,
};
